import { useCallback } from 'react'

import { useMutation, useQueryClient } from 'react-query'

import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'

interface AddParams {
  word: string
  blockAllCombinations: boolean
}

export function useAddRestrictedWord() {
  const queryClient = useQueryClient()

  const addMutation = useMutation(
    ({ word, blockAllCombinations }: AddParams) =>
      restrictedWordsService.addRestrictedWord(word, blockAllCombinations),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['restrictedWords'])
      },
    },
  )

  const addRestrictedWord = useCallback(
    (params: AddParams) => {
      return addMutation.mutateAsync(params)
    },
    [addMutation],
  )

  return {
    addRestrictedWord,
    isAddRestrictedWordLoading: addMutation.isLoading,
  }
}
